import { MomentDateAdapter } from '@angular/material-moment-adapter'
import { SubSink } from 'subsink'

/**
 * A class that automatically unsubscribes all observables when
 * the object gets destroyed
 */
export class CustomMomentAdapter extends MomentDateAdapter {
    /** The subscription sink object that stores all subscriptions */
    subscriptions = new SubSink()

    getFirstDayOfWeek(): number {
        return 1
    }
}
